// extracted by mini-css-extract-plugin
module.exports = {"back_arrow":"BackArrow_back_arrow__Bk4ab"};